var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('BaseLink',{staticClass:"cookie-bar-settings-link",attrs:{"bem-modifiers":['background-casto-yellow', 'button-like'],"href":(_vm.baseUrl + "/regulaminy/pliki-cookies")}},[_vm._v("\n    Zmień ustawienia\n")])}
var staticRenderFns = []

export { render, staticRenderFns }